module.exports = __webpack_public_path__ + "img/e5.85d1341f.jpg";